<template lang="pug">
  .component-backoffice-driver-approval.row.column
    .row
      .columns.large-4.small-12
        SearchEntity(entity="drivers", v-model="search.driver_id" )
      .columns
        AccontStatusFilter(:statuses="['document_status','subscription']", v-model="search")
    base-list(
      :component="component",
      :dataLoader="dataLoader",
      :search="search",
      componentType="approvalListing"
    )
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'

  import BaseList from './BaseList'
  import SelectizeDriver from '../../components/structure/ui/lists/selectize/SelectizeDriver'
  import AccontStatusFilter from '../../components/backoffice/tabbed/AccontStatusFilter'
  import SearchEntity from "../../components/structure/ui/SearchEntity.vue";

  export default {
    name: 'DriverApprovalQueue',
    components: {
      SearchEntity,
      AccontStatusFilter,
      SelectizeDriver,
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Driver.vue'),
        headers: [' ', 'Driver ID / Name', 'City', 'Requested date', 'Phone & Mail', ''],
        search: {
          status: ['PENDING REVIEW', 'ON HOLD'],
          order_field: 'updated_at',
          sort_order: 'desc',
          driver_id: null,
          payment_method: 0,
          document: 0,
          subscription: 0,
        },
      }
    },
    methods: {
      dataLoader(callback, page, resultsPerPage, search) {
        KeplerBackofficeSdk.drivers.list(page, resultsPerPage, search).approval((data) => {
          callback(data)
        })
      },
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .component-backoffice-driver-approval
    .activeIcon
      color: #64db6f
</style>



// WEBPACK FOOTER //
// DriverApprovalQueue.vue?37c69860